import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/pages/HomePage.vue'
import AboutPage from '@/pages/AboutPage.vue'
import FAQPage from '@/pages/FAQPage.vue'
import ArchivePage from '@/pages/ArchivePage.vue'
import SearchHelpPage from '@/pages/SearchHelpPage.vue'
import PressPage from '@/pages/PressPage.vue'
import ContactPage from '@/pages/ContactPage.vue'
import MediaDetailPage from '@/pages/MediaDetailPage.vue'
import PrivacyClausePage from '@/pages/PrivacyClausePage.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/about',
      name: 'about',
      component: AboutPage
    },
    {
      path: '/about/faq',
      name: 'faq',
      component: FAQPage
    },
    {
      path: '/archive',
      name: 'archive',
      component: ArchivePage
    },
    {
      path: '/archive/help',
      name: 'searchhelp',
      component: SearchHelpPage
    },
    {
      path: '/press',
      name: 'press',
      component: PressPage
    },
    {
      path: '/contact',
      name: 'contact',
      component: ContactPage
    },
    {
      path: '/contact/privacy-clause',
      name: 'privacy',
      component: PrivacyClausePage
    },
    {
      path: '/medienarchiv/:slug',
      name: 'mediadetail',
      component: MediaDetailPage
    },
    {
      path: '*',
      component: HomePage
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js